import React, { useState, useEffect } from "react";
import "./popup.css";

const Popup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(0);

  const closePopup = () => {
    setIsOpen(false);
  };

  const handleImageLoad = () => {
    setImagesLoaded((prev) => Math.min(prev + 1, 2));
  };

  const handleImageError = () => {
    setImagesLoaded((prev) => Math.min(prev + 1, 2));
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const allImagesLoaded = imagesLoaded >= 2;

  return (
    <>
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="popup-close" onClick={closePopup}>
              <i className="fa fa-times"></i>
            </button>
            <div className="popup-body">
              <div className="popup-media">
                <img
                  src="./images/popupPost.jpg"
                  alt="Popup Post"
                  className="popup-image web-view"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                />
                <img
                  src="./images/post1.jpg"
                  alt="Popup Post Mobile"
                  className="popup-image mobile-view"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                />
                {!allImagesLoaded && (
                  <div className="popup-loading">Loading preview...</div>
                )}
              </div>

              {allImagesLoaded && (
                <button
                  className="popup-cta primary-btn"
                  onClick={() => window.location.href = 'https://forms.gle/8VDquZw969Arwxj77'}
                >
                  Register To Start Your Journey
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
